/**
 * @generated SignedSource<<4f8eb7accc216efb31d06e80ee90f5d6>>
 * @relayHash b20d7fd54e173a10f2f0e9d8eafff534
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 83749e81c54a4fcf337925d0da91df62a3227b56e9d5f142b2e438fa843ea8f8

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { ui_jiraCapacityQuery } from './ui_jiraCapacityQuery.graphql';

const node: PreloadableConcreteRequest<ui_jiraCapacityQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "83749e81c54a4fcf337925d0da91df62a3227b56e9d5f142b2e438fa843ea8f8",
    "metadata": {},
    "name": "ui_jiraCapacityQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
